function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.554 19.254a2.138 2.138 0 10.864 1.014l2.881-2.013a2.143 2.143 0 001.71.478l.878 2.426a2.138 2.138 0 103.107 1.102l2.997-2.093a2.138 2.138 0 10-.628-.903l-2.998 2.094a2.128 2.128 0 00-1.418-.503l-.93-2.568a2.138 2.138 0 10-3.348-.936l-2.917 2.039a2.142 2.142 0 00-.198-.137z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.464 2a1 1 0 10-2 0v2.733H3.867A2.867 2.867 0 001 7.6v20.533A2.867 2.867 0 003.867 31h24.266A2.867 2.867 0 0031 28.133V7.6a2.867 2.867 0 00-2.867-2.867h-4.602V2a1 1 0 10-2 0v2.733H10.464V2zm17.67 4.733c.478 0 .866.388.866.867v1.8H3V7.6c0-.479.388-.867.867-.867h24.266zm.866 21.4V11.4H3v16.733c0 .479.388.867.867.867h24.266a.867.867 0 00.867-.867z",
  fill: "currentColor"
})));